import { defineStore } from "pinia";
import type { IEnvironmentConfig } from "~/types/store";

interface IEnvironmentConfigStoreState {
  environmentConfig: IEnvironmentConfig;
}

export const useEnvironmentConfigStore = defineStore("environmentConfig", {
  state: (): IEnvironmentConfigStoreState => ({
    environmentConfig: {
      authorsPerPage: 10,
      articlesPerPage: 10,
      isCallForPapersVisible: false,
      isImpactMetricsVisible: true,
      isResearchTopicImportantNoteVisible: true,
      showRtImpactTab: true,
      showInstitutionsBlock: true,
      minimumRtDownloadsCount: 10,
      isManuscriptButtonVisible: undefined,
      useNewParticipateUrl: false
    }
  }),
  getters: {
    getConfig: (state) => () => state.environmentConfig
  },
  actions: {
    fetchValidatedConfig() {
      const {
        isCallForPapersVisible,
        isImpactMetricsVisible,
        isResearchTopicImportantNoteVisible,
        showRtImpactTab,
        showInstitutionsBlock,
        minimumRtDownloadsCount,
        authorsPerPage,
        articlesPerPage,
        isManuscriptButtonVisible,
        useNewParticipateUrl
      } = useRuntimeConfig().public;

      this.environmentConfig = {
        authorsPerPage: parseInt(authorsPerPage),
        articlesPerPage: parseInt(articlesPerPage),
        isCallForPapersVisible: useEnvBoolean(isCallForPapersVisible),
        isImpactMetricsVisible: useEnvBoolean(isImpactMetricsVisible),
        isResearchTopicImportantNoteVisible: useEnvBoolean(
          isResearchTopicImportantNoteVisible
        ),
        showRtImpactTab: useEnvBoolean(showRtImpactTab),
        showInstitutionsBlock: useEnvBoolean(showInstitutionsBlock),
        isManuscriptButtonVisible: useEnvBoolean(isManuscriptButtonVisible),
        useNewParticipateUrl: useEnvBoolean(useNewParticipateUrl),
        minimumRtDownloadsCount: parseInt(minimumRtDownloadsCount) ?? 10
      };
    }
  }
});
